import { ChevronLeftIcon } from "@heroicons/react/solid";
import Title from "../Title";

import NewsItem from "./NewsItem";

const News = () => {
    const newsDetalis = [
        {
            id: 0,
            type: "اطلاعیه",
            title: "اعلام ساعت کاری کتابخانه و مرکز خدمات",
            description: `
            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است.
            `,
        },
        {
            id: 1,
            type: "خبر",
            title: "اعلام ساعت کاری کتابخانه و مرکز خدمات",
            description: `
            با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و
            سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزار
            `,
        },
        {
            id: 2,
            type: "اطلاعیه",
            title: "اعلام ساعت کاری کتابخانه و مرکز خدمات",
            description: `
            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است.
            `,
        },
    ];

    return (
        <section className="news container flex flex-wrap h-[450px] bg-slate-50 rounded-t-[45px] relative bottom-11">
            <div className="w-4/6">
                <Title width="fit">اخبار و اطلاعیه های مهم کتابخانه</Title>
                <div className="my-12 flex flex-col justify-between h-[60%]">
                    {newsDetalis.map((news) => (
                        <NewsItem type={news.type} title={news.title} key={news.id}>
                            {news.description}
                        </NewsItem>
                    ))}
                </div>
            </div>

            <div className="w-2/6 p-1">
                <Title width="fit">رویدادهای مهم</Title>
                <div className="m-12">
                    <h5 className="font-bold mb-1">هفته کتاب و کتاب خوانی</h5>
                </div>
            </div>

            <div className="flex mx-auto font-bold h-fit">
                <div>
                    <ChevronLeftIcon className="w-7 text-sky-900" />
                </div>
                مشاهده همه اخبار و اطلاعیه ها
            </div>
        </section>
    );
};

export default News;
